function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Modal, message } from 'antd';
import Moment from 'react-moment';
import Common from './includes/Common';
import { CheckCircleFill } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ConfigurationListView = function ConfigurationListView(_ref) {
  var _ref$configurationLis = _ref.configurationList,
    configurationList = _ref$configurationLis === void 0 ? [] : _ref$configurationLis,
    dataRefresh = _ref.dataRefresh;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    arrayData = _useState2[0],
    setArrayData = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedConfig = _useState4[0],
    setSelectedConfig = _useState4[1];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Pv Ess."
    }),
    dataIndex: 'petrol_user_price',
    key: 'petrol_user_price',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Pv Gaz."
    }),
    dataIndex: 'diesel_user_price',
    key: 'diesel_user_price',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Pa. Es."
    }),
    responsive: ['lg', 'md', 'sm'],
    dataIndex: 'petrol_purchase_price',
    key: 'petrol_purchase_price',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Pa. Gaz."
    }),
    responsive: ['lg', 'md', 'sm'],
    dataIndex: 'diesel_purchase_price',
    key: 'diesel_purchase_price',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {}),
    dataIndex: 'config',
    responsive: ['lg', 'md', 'sm'],
    key: 'config',
    render: function render(config) {
      return /*#__PURE__*/_jsx(Space, {
        direction: "horizontal",
        children: config.default_selected == 0 ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [ContextHolder, /*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              handleDefault(config);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "PAR DEFAUT"
            })
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [ContextHolder, /*#__PURE__*/_jsx(Button, {
            style: {
              width: '100px'
            },
            disabled: true,
            type: "link",
            children: /*#__PURE__*/_jsx(CheckCircleFill, {
              size: 25
            })
          })]
        })
      });
    }
  }];
  var handleDefault = function handleDefault(c) {
    setSelectedConfig(c);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous la configuration par defaut ? "
      }),
      content: /*#__PURE__*/_jsxs("ul", {
        children: [/*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "Prix Essence \xE0 la pompe: "
          }), c.petrol_user_price.toLocaleString('Fr')]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "Prix Eazoil \xE0 la pompe:"
          }), " ", c.diesel_user_price.toLocaleString('Fr')]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "Prix d'achat Essence:"
          }), " ", c.petrol_purchase_price.toLocaleString('Fr')]
        }), /*#__PURE__*/_jsxs("li", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "Prix d'achat Gazoil:"
          }), " ", c.diesel_purchase_price.toLocaleString('Fr')]
        })]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "makedefaultconfiguration", {
          configuration_id: c.id,
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            message.success({
              content: response.data.message,
              delay: 4
            });
            dataRefresh();
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.success({
            content: 'Une erreur est survenue',
            delay: 4
          });
        })["finally"](function () {});
      }
    });
  };
  useEffect(function () {
    setArrayData([]);
    configurationList.forEach(function (c) {
      setArrayData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: c.id,
          date: c.created_at,
          petrol_user_price: c.petrol_user_price,
          diesel_user_price: c.diesel_user_price,
          petrol_purchase_price: c.petrol_purchase_price,
          diesel_purchase_price: c.diesel_purchase_price,
          config: c
        }]);
      });
    });
  }, [configurationList]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h6", {
      children: /*#__PURE__*/_jsx("b", {
        children: "CONFIGURATION DE PRIX"
      })
    }), /*#__PURE__*/_jsx(Table, {
      bordered: true,
      size: "small",
      columns: cols,
      dataSource: arrayData
    })]
  });
};
export default ConfigurationListView;